(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["FAQ-section"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faq-accordion')) {
    customElements.define(
      'faq-accordion',
      class FaqAccordion extends HTMLElement {
        connectedCallback() {
          this.items = Array.from(this.querySelectorAll('.faq-accordion__item'));
          this.querySelectorAll('.faq-accordion__question').forEach((btn) => {
            btn.addEventListener('click', () => this.toggle(btn));
          });
        }

        toggle(btn) {
          const item = btn.closest('.faq-accordion__item');
          if (!item) return;
          const willOpen = !item.classList.contains('is-open');

          // Close every item first so only one stays open at a time.
          this.items.forEach((i) => {
            i.classList.remove('is-open');
            const b = i.querySelector('.faq-accordion__question');
            if (b) b.setAttribute('aria-expanded', 'false');
          });

          if (willOpen) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var SLIDE_INTERVAL_MS = 3500;
    var MOBILE_MAX = 767;
    var RESUME_DELAY_MS = 5000;

    function isMobile() {
      return window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)').matches;
    }

    function initAutoplay(grid) {
      if (grid._autoplayInit) return;
      grid._autoplayInit = true;

      var interval = null;
      var paused = false;
      var resumeTimer = null;

      function tick() {
        if (paused || !isMobile()) return;
        var cards = grid.querySelectorAll('.card');
        if (cards.length < 2) return;

        var cardWidth = cards[0].offsetWidth + 16; // card width + gap
        var maxScroll = grid.scrollWidth - grid.clientWidth;
        var atEnd = grid.scrollLeft >= maxScroll - 4;

        if (atEnd) {
          grid.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          grid.scrollBy({ left: cardWidth, behavior: 'smooth' });
        }
      }

      function start() {
        stop();
        if (!isMobile()) return;
        interval = setInterval(tick, SLIDE_INTERVAL_MS);
      }

      function stop() {
        if (interval) {
          clearInterval(interval);
          interval = null;
        }
      }

      function pauseTemporarily() {
        paused = true;
        if (resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () {
          paused = false;
        }, RESUME_DELAY_MS);
      }

      grid.addEventListener('touchstart', pauseTemporarily, { passive: true });
      grid.addEventListener('mousedown',  pauseTemporarily);

      start();

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          if (isMobile()) start();
          else stop();
        }, 200);
      });
    }

    /* ── Outer-layout Swiper carousel ──────────────────────────────────
       Initialised only on .custom-product__swiper (rendered when the
       "Enable slider" setting is on). Targeting this unique class means the
       outer Swiper never touches the cards' own inner .card-media-swiper
       image sliders — those keep being initialised by custom-collection.js.
       All config is read from data-* attributes emitted by the section. */
    function num(el, attr, fallback) {
      var v = parseFloat(el.getAttribute(attr));
      return isNaN(v) ? fallback : v;
    }

    // Swiper is loaded with `defer` in <head>. On the storefront our section
    // script can run before that deferred bundle has executed, so window.Swiper
    // may not exist yet on the first (and only) init attempt — unlike the Theme
    // Editor, which re-fires shopify:section:load long after Swiper is ready.
    // Rather than bail (which leaves the raw flex wrapper = one giant card), we
    // wait for Swiper to appear, then run the callback. Bounded so it can't spin
    // forever if the bundle genuinely failed to load.
    function whenSwiperReady(cb) {
      if (typeof window.Swiper !== 'undefined') { cb(); return; }
      var tries = 0;
      var timer = setInterval(function () {
        if (typeof window.Swiper !== 'undefined') {
          clearInterval(timer);
          cb();
        } else if (++tries > 150) {   // ~15s safety cap
          clearInterval(timer);
        }
      }, 100);
    }

    // Fully tear down any Swiper instance AND any pending width-watcher left on
    // this element by a previous render. Returns nothing; leaves the element clean.
    function teardownProductSwiper(el) {
      if (el._cpWidthObserver) {
        el._cpWidthObserver.disconnect();
        el._cpWidthObserver = null;
      }
      if (el.swiper && typeof el.swiper.destroy === 'function') {
        el.swiper.destroy(true, true);
      }
    }

    // Actually create the Swiper. Only ever called once the element is connected
    // and has a real, non-zero width — so breakpoints + slidesPerView resolve
    // against the true container size instead of 0 (which is what produced the
    // single oversized slide after a Theme Editor re-render).
    function createProductSwiper(el) {
      if (!el.isConnected || typeof window.Swiper === 'undefined') return;
      teardownProductSwiper(el);

      var spvDesktop = num(el, 'data-spv-desktop', 4);
      var spvTablet  = num(el, 'data-spv-tablet', 2.5);
      var spvMobile  = num(el, 'data-spv-mobile', 1.4);
      var gap        = num(el, 'data-gap', 16);
      var useNav     = el.getAttribute('data-nav') === 'true';
      var usePag     = el.getAttribute('data-pagination') === 'true';
      var useDrag    = el.getAttribute('data-drag') === 'true';

      var opts = {
        slidesPerView: spvMobile,
        spaceBetween: gap,
        // Centered + bounds → the luxury "½ · full · full · full · ½" peek in
        // the middle, while the first/last slides still sit flush to the edges.
        centeredSlides: true,
        centeredSlidesBounds: false,
        grabCursor: useDrag,
        allowTouchMove: useDrag,
        watchOverflow: true,
        // Swiper's own ResizeObserver (on by default) keeps widths + the active
        // breakpoint correct on any later size change. We do NOT add a
        // MutationObserver here: it reacts to the editor's attribute/childList
        // churn, not to the 0→real width transition that was the real bug.
        breakpoints: {
        768: {
          slidesPerView: spvTablet,
          centeredSlides: true,
          centeredSlidesBounds: true
        },
        1024: {
          slidesPerView: spvDesktop,
          centeredSlides: true,
          centeredSlidesBounds: true
        }
      }
      };

      if (useNav) {
        opts.navigation = {
          prevEl: el.querySelector('.custom-product__nav-prev'),
          nextEl: el.querySelector('.custom-product__nav-next')
        };
      }

      if (usePag) {
        // Pagination lives just outside .swiper (sibling), so query the carousel.
        var carousel = el.closest('.custom-product__carousel') || el.parentNode;
        var pagEl = carousel ? carousel.querySelector('.custom-product__pagination') : null;
        if (pagEl) {
          opts.pagination = { el: pagEl, clickable: true };
        }
      }

      new window.Swiper(el, opts);
    }

    // Entry point. Guarantees Swiper is only built once the section has a real
    // layout width. In the Theme Editor the section is re-rendered on every
    // settings change and the new markup is briefly width:0 while it reflows —
    // initialising then makes Swiper resolve slidesPerView to ~1 and show one
    // giant card. So if width is 0 we wait (ResizeObserver) for the real width.
    function initProductSwiper(el) {
      // Defer until the Swiper bundle has actually loaded (see whenSwiperReady).
      // This is the fix for "works in editor, one card on storefront".
      if (typeof window.Swiper === 'undefined') {
        whenSwiperReady(function () { initProductSwiper(el); });
        return;
      }
      teardownProductSwiper(el);

      if (el.offsetWidth > 0) {
        createProductSwiper(el);
        return;
      }

      if (typeof ResizeObserver !== 'undefined') {
        var ro = new ResizeObserver(function () {
          if (el.offsetWidth > 0) {
            ro.disconnect();
            el._cpWidthObserver = null;
            createProductSwiper(el);
          }
        });
        el._cpWidthObserver = ro;
        ro.observe(el);
      } else {
        // Legacy fallback: defer two frames so layout settles before measuring.
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { createProductSwiper(el); });
        });
      }
    }

    function destroyProductSwipers(root) {
      var scope = root || document;
      scope.querySelectorAll('.sec__custom-product .custom-product__swiper').forEach(teardownProductSwiper);
    }

    // Used by the lighter editor events (select): refresh an existing instance,
    // or build one if it isn't there yet (e.g. the section was just revealed).
    function refreshProductSwipers(root) {
      var scope = root || document;
      scope.querySelectorAll('.sec__custom-product .custom-product__swiper').forEach(function (el) {
        if (el.swiper && !el.swiper.destroyed) {
          el.swiper.update();
        } else {
          initProductSwiper(el);
        }
      });
    }

    function initAll(root) {
      var scope = root || document;
      var grids = scope.querySelectorAll('.sec__custom-product .col-grid');
      grids.forEach(initAutoplay);

      var swipers = scope.querySelectorAll('.sec__custom-product .custom-product__swiper');
      swipers.forEach(initProductSwiper);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    // ── Shopify Theme Editor lifecycle ───────────────────────────────────
    // load/reorder fully (re)build (DOM was re-rendered); unload tears down so
    // instances + observers never pile up; select just refreshes measurements.
    document.addEventListener('shopify:section:load',    function (e) { initAll(e.target); });
    document.addEventListener('shopify:section:reorder', function (e) { initAll(e.target); });
    document.addEventListener('shopify:section:unload',  function (e) { destroyProductSwipers(e.target); });
    document.addEventListener('shopify:section:select',  function (e) { refreshProductSwipers(e.target); });
    document.addEventListener('shopify:block:select',    function (e) { refreshProductSwipers(e.target); });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faq-accordion')) {
    customElements.define(
      'faq-accordion',
      class FaqAccordion extends HTMLElement {
        connectedCallback() {
          this.items = Array.from(this.querySelectorAll('.faq-accordion__item'));
          this.querySelectorAll('.faq-accordion__question').forEach((btn) => {
            btn.addEventListener('click', () => this.toggle(btn));
          });
        }

        toggle(btn) {
          const item = btn.closest('.faq-accordion__item');
          if (!item) return;
          const willOpen = !item.classList.contains('is-open');

          // Close every item first so only one stays open at a time.
          this.items.forEach((i) => {
            i.classList.remove('is-open');
            const b = i.querySelector('.faq-accordion__question');
            if (b) b.setAttribute('aria-expanded', 'false');
          });

          if (willOpen) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scent-collection-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scent-collection-slider')) {
    customElements.define(
      'scent-collection-slider',
      class ScentCollectionSlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.scent-collection-slider__track');
          this.initDragScroll();
          this.initCardMedia();
        }

        // Drag-to-scroll for desktop mouse users (touch/trackpad use native scroll).
        initDragScroll() {
          const track = this.track;
          if (!track) return;

          let down = false;
          let moved = false;
          let startX = 0;
          let startLeft = 0;

          track.addEventListener('pointerdown', (e) => {
            if (e.pointerType !== 'mouse') return;
            if (e.target.closest('button, a, input, select, .scent-collection-slider__media')) return;
            down = true;
            moved = false;
            startX = e.clientX;
            startLeft = track.scrollLeft;
            track.setPointerCapture(e.pointerId);
          });

          track.addEventListener('pointermove', (e) => {
            if (!down) return;
            const dx = e.clientX - startX;
            if (Math.abs(dx) > 4 && !moved) {
              moved = true;
              track.classList.add('is-dragging');
            }
            if (moved) track.scrollLeft = startLeft - dx;
          });

          const stop = (e) => {
            if (!down) return;
            down = false;
            if (track.hasPointerCapture && track.hasPointerCapture(e.pointerId)) {
              track.releasePointerCapture(e.pointerId);
            }
            // Drop the dragging state after this event loop so the click guard can fire.
            requestAnimationFrame(() => track.classList.remove('is-dragging'));
          };
          track.addEventListener('pointerup', stop);
          track.addEventListener('pointercancel', stop);

          // Swallow the click that ends a drag so cards don't navigate.
          track.addEventListener(
            'click',
            (e) => {
              if (moved) {
                e.preventDefault();
                e.stopPropagation();
                moved = false;
              }
            },
            true
          );
        }

        // Per-card image carousel: keep the dots in sync and make them clickable.
        initCardMedia() {
          this.querySelectorAll('.scent-collection-slider__media[data-multi]').forEach((media) => {
            const mediaTrack = media.querySelector('.scent-collection-slider__media-track');
            const dots = Array.from(media.querySelectorAll('.scent-collection-slider__dot'));
            if (!mediaTrack || dots.length < 2) return;

            let ticking = false;
            const sync = () => {
              const index = Math.round(mediaTrack.scrollLeft / mediaTrack.clientWidth);
              dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
            };

            mediaTrack.addEventListener(
              'scroll',
              () => {
                if (ticking) return;
                ticking = true;
                requestAnimationFrame(() => {
                  ticking = false;
                  sync();
                });
              },
              { passive: true }
            );

            dots.forEach((dot, i) => {
              dot.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                mediaTrack.scrollTo({ left: i * mediaTrack.clientWidth, behavior: 'smooth' });
              });
            });

            // Hover autoplay (hover-capable devices only): gently cycle through the
            // card's images while the card is hovered, then stop when hover ends.
            // Reuses the same smooth scroll + snap as the dots, so the dots stay in
            // sync and manual dot/drag interaction keeps working. Scoped to the inner
            // media carousel — the outer card slider is untouched.
            if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
              const card = media.closest('.scent-collection-slider__card') || media;
              const SLIDE_INTERVAL = 1800;
              let autoplayTimer = null;

              const advance = () => {
                const slideW = mediaTrack.clientWidth;
                if (!slideW) return;
                const current = Math.round(mediaTrack.scrollLeft / slideW);
                const next = (current + 1) % dots.length;
                mediaTrack.scrollTo({ left: next * slideW, behavior: 'smooth' });
              };

              const startAutoplay = () => {
                if (autoplayTimer) return;
                autoplayTimer = setInterval(advance, SLIDE_INTERVAL);
              };

              const stopAutoplay = () => {
                clearInterval(autoplayTimer);
                autoplayTimer = null;
              };

              card.addEventListener('mouseenter', startAutoplay);
              card.addEventListener('mouseleave', stopAutoplay);
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
